import { z } from 'zod';
import { stampedBody } from '../common/row-version.js';
import { LanguageSchema } from '../common/language.js';
import { ImportFormatSchema } from '../import-export/envelopes.js';
// Asset owners — globally-pooled, deliberately THIN (a label finance points at,
// not a CRM record — SCHEMA §asset_owners). Defined via reference_data:manage
// (define-vs-use: books people PICK owners; transfer is asset.books:write).
// The pivot row is the sharing declaration (ADR-066 attachment invariant).
// Lifecycle (disable / reactivate) rides its own routes so the audit reads the
// state change, never an edit (the flat reference-data archetype).
export const ASSET_OWNER_KINDS = ['our_company', 'customer', 'lessor', 'other'];
export const AssetOwnerKindSchema = z.enum(ASSET_OWNER_KINDS);
export const CreateAssetOwnerSchema = z
    .object({
    name: z.string().trim().min(1).max(64),
    code: z.string().trim().min(1).max(32).nullable().optional(),
    kind: AssetOwnerKindSchema,
})
    .strict();
export const UpdateAssetOwnerSchema = z
    .object({
    ...stampedBody,
    name: z.string().trim().min(1).max(64).optional(),
    code: z.string().trim().min(1).max(32).nullable().optional(),
    kind: AssetOwnerKindSchema.optional(),
})
    .strict();
export const AssociateAssetOwnerSchema = z
    .object({ id: z.string().min(1).max(16) })
    .strict();
export const AssetOwnerSearchQuerySchema = z
    .object({ q: z.string().trim().min(1).max(64) })
    .strict();
// ── GET /api/projects/:projectId/asset-owners/export — current-view export ────
// Mirrors the list's URL view-state so the file IS what the user sees (ADR-045).
// `status`/`kind` arrive comma-separated (the list filters); `q` is the search.
const csvFilter = z.preprocess((v) => (typeof v === 'string' ? v.split(',').map((s) => s.trim()).filter(Boolean) : v), z.array(z.string().max(64)).max(50).optional());
export const ExportAssetOwnersQuerySchema = z
    .object({
    format: ImportFormatSchema.default('xlsx'),
    lang: LanguageSchema.default('en'),
    status: csvFilter,
    kind: csvFilter,
    q: z.string().trim().max(100).optional(),
})
    .strict();
